module.exports = __webpack_public_path__ + "img/settings-user.d6672740.svg";